import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Select from "react-select";
//import Button from 'react-bootstrap/Button';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const GridList = (props) => {
  const newOpt = [
    {
      value: "tab1",
      label: "First Section",
    },
    {
      value: "tab2",
      label: "Second Section",
    },
    {
      value: "tab3",
      label: "Third Section",
    },
  ];
  const [characters, updateCharacters] = useState([]);
  const [options, setOptions] = useState(props.data);
  const [newItem, setnewItem] = useState("");
  const [newOption, setnewOption] = useState("");

  /* const newContainer = (event)=>{
      event.preventDefault();
      const newer ={
        "value":"unnamedItem",
        "label":"unamedItem",
        "order":characters.length+1,
        "id":characters.length+1
      }
      updateCharacters([...characters, newer]);
      
    } */

  const checkValueExist = (value) => {
    return characters.some(function (el) {
      return el.value === value;
    });
  };
  const newContainer = () => {
    if (!checkValueExist(newItem.value)) {
      const newer = {
        value: newItem.value,
        label: newItem.label,
        order: characters.length + 1,
        id: newItem.value,
        type: newOption.label,
        draft: true,
        publish: false,
      };

      updateCharacters([...characters, newer]);

      const newArr = [...characters, newer];
      props.onChange(newArr);
      setnewItem("");
      setnewOption("");
    } else {
      toastr.error("Element Already Exist", "Error");
      setnewItem("");
      setnewOption("");
    }
  };

  const onChangeItem = (value) => {
    const newer = {
      value: value.value,
      label: value.label,
      order: characters.length + 1,
      id: value.value,
      type: value.type,
    };
    setnewItem(newer);
  };

  const onChangeOpt = (value) => {
    const newer = {
      value: value.value,
      label: value.label,
    };
    setnewOption(newer);
  };

  useEffect(() => {
    setOptions([...props.data]);
    const getDetails = () => {
      const opt = props.listData.map((item) => ({
        value: item.itemid,
        label:
          props.list.length > 0
            ? findObject(props.list, item.itemid) === ""
              ? item.itemRef
              : findObject(props.list, item.itemid)
            : item.itemRef,
        order: item.itemOrder,
        id: item.itemid,
        type: item.itemType,
        draft:
          props.list.length > 0
            ? findObjectStatus(props.list, item.itemid)
            : true,
        publish:
          props.list.length > 0
            ? findObjectPublish(props.list, item.itemid)
            : false,
      }));

      updateCharacters(opt);
    };

    const findObject = (array, id) => {
      let obj = array.find((x) => x._id === id);
      if (obj) {
        return obj.referenceName;
      } else {
        return "";
      }
    };

    const findObjectStatus = (array, id) => {
      let obj = array.find((x) => x._id === id);
      if (obj) {
        return obj.draftStatus;
      } else {
        return false;
      }
    };
    const findObjectPublish = (array, id) => {
      let obj = array.find((x) => x._id === id);
      if (obj) {
        return obj.publishStatus;
      } else {
        return false;
      }
    };

    getDetails();
  }, [props.data, props.listData, props.list]);
  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    updateCharacters(newItems);
    const newArr = newItems;
    props.onChange(newArr);
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);
    reorderArray(items);
  };

  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(index, 1);

    reorderArray(items);
  };

  return (
    <div className="row mb-2 mt-2">
      {props.dir === "rtl" && <div className="col-sm-2"></div>}
      <div className="col-sm-10">
        <div className="form-group">
          <div className="row">
            {props.dir === "rtl" && (
              <div className="float-right col-md-2">
                <button
                  type="button"
                  className={"btn btn-light btn-block"}
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                  onClick={newContainer}
                >
                  Save
                </button>
              </div>
            )}
            <div className="col-md-4" dir={props.dir === "rtl" ? "rtl" : "ltr"}>
              <Select
                name="headerList"
                className={
                  props.dir === "rtl"
                    ? "form-control inside-select float-right"
                    : "form-control inside-select float-left"
                }
                options={newOpt}
                onChange={onChangeOpt}
                value={newOption}
              ></Select>
            </div>
            <div className="col-md-6" dir={props.dir === "rtl" ? "rtl" : "ltr"}>
              <Select
                name="containerList"
                className={
                  props.dir === "rtl"
                    ? "form-control inside-select float-right"
                    : "form-control inside-select float-left"
                }
                options={options}
                onChange={onChangeItem}
                value={newItem}
              ></Select>
            </div>
            {!(props.dir === "rtl") && (
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                  onClick={newContainer}
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId={"characters"}>
            {(provided) => (
              <ul
                className="products-list product-list-in-card pl-2 pr-2"
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{ maxHeight: "350px", overflowY: "scroll" }}
              >
                {characters.map((item, index) => (
                  <Draggable
                    key={item.id + item.order}
                    draggableId={"item" + item.id}
                    index={index}
                  >
                    {(provided) => (
                      <li
                        className="item"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="product-info">
                          <a
                            href={
                              props.listType === "element" &&
                              item.type !== "tabItem"
                                ? "/item/" + item.type + "/" + item.id
                                : props.listType === "element" &&
                                    item.type !== "textgrid"
                                  ? "/item/" + item.type + "/" + item.id
                                  : props.listType === "element" &&
                                      item.type === "tabItem"
                                    ? "/tab/" + item.id
                                    : "/" +
                                      (item.type + "").toLowerCase() +
                                      "/" +
                                      item.id
                            }
                            className="product-title"
                          >
                            {}
                            {item.label}
                            <span className="badge badge-warning float-left">
                              {item.order}
                            </span>
                          </a>
                          <div
                            className="text-right"
                            style={{ display: "inline", float: "right" }}
                          >
                            <label
                              className={
                                item.draft && item.publish
                                  ? "badge badge-success"
                                  : "badge badge-danger"
                              }
                            >
                              {item.draft && item.publish
                                ? "Published"
                                : "Draft"}
                            </label>
                            <a
                              className="btn btn-light btn-sm"
                              href="#!"
                              onClick={(event) => handleRemove(event, index)}
                            >
                              <i className="fas fa-trash"></i>
                            </a>
                          </div>
                          <span
                            className="product-description"
                            style={{ marginLeft: "55px" }}
                          >
                            {item.type}
                          </span>
                        </div>
                      </li>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

export default GridList;
